import { defineStore } from 'pinia';
import { api } from '../boot/axios'

export const useScheduleStore = defineStore('schedule', {
  persist: true,

  state: () => ({
    schedules: []
  }),

  getters: {
    getSchedulesByEmployeeID: (state) => (employeeId) => {
      return state.schedules.filter(schedule => schedule.employeeID === employeeId) || {}
    },
  },

  actions: {
    async fetchSchedules (criteria) {
      const response = await api.get('api/v1/schedules', {
        params: {
          startDate: criteria.startDate,
          endDate: criteria.endDate
        }
      })
      this.schedules = response.data
    }
  }

})
